import { useTranslation } from 'react-i18next';
import { Eye, Globe, Lock } from 'lucide-react';
import { SignalVisibilityType } from '@momentum/types';
import { PropertyRow } from '@/shared/components/ui/PropertyRow';
import { ChipToggle } from '@/shared/components/ui/ChipToggle';

interface VisibilityToggleProps {
  value: SignalVisibilityType;
  onChange: (value: SignalVisibilityType) => void;
}

export const VisibilityToggle = ({
  value,
  onChange,
}: VisibilityToggleProps) => {
  const { t } = useTranslation('knowledge');

  return (
    <PropertyRow
      icon={<Eye />}
      label={t('marketplaceLabel')}
      tooltip={t('marketplaceTooltip')}
    >
      <ChipToggle
        options={[
          {
            value: SignalVisibilityType.PUBLIC,
            label: t('marketplacePublic'),
            icon: <Globe />,
            activeColor: {
              bg: 'bg-green-600/8',
              text: 'text-green-800',
              border: 'border-green-600/25',
              iconColor: 'text-green-600',
            },
          },
          {
            value: SignalVisibilityType.PRIVATE,
            label: t('marketplacePrivate'),
            icon: <Lock />,
            activeColor: {
              bg: 'bg-amber-600/8',
              text: 'text-amber-800',
              border: 'border-amber-600/25',
              iconColor: 'text-amber-600',
            },
          },
        ]}
        value={value}
        onChange={(visibility) => onChange(visibility as SignalVisibilityType)}
      />
    </PropertyRow>
  );
};
